import React from 'react';
import List from "semantic-ui-react/dist/es/elements/List/List.js";
import { GridColumn } from "../../../layout/GridColumn";
import { Icon } from "../../../elements/Icon";
import { Paragraph } from "../../../typography/Paragraph";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
export var getRoomFeaturesMarkup = function getRoomFeaturesMarkup(showIcons, features) {
  return React.createElement(GridColumn, {
    as: List,
    className: "only-horizontal-padding",
    computer: 12,
    floated: "left",
    horizontal: true
  }, features.map(function (_ref, index) {
    var labelText = _ref.labelText,
        iconName = _ref.iconName;
    return React.createElement(List.Item, {
      key: buildKeyFromStrings(labelText, index)
    }, showIcons ? React.createElement(Paragraph, null, labelText) : React.createElement(Icon, {
      labelText: labelText,
      name: iconName,
      size: "small"
    }));
  }));
};